import React from 'react'
import './Bubble.scss'
import Markdown from "react-markdown"
import Paragraph from "src/components/Paragraph/Paragraph"
import { formatTimeToHoursMinute, getStyles } from "src/helpers"
import { IBubble } from "src/components/Bubble/types"

const Bubble: React.FC<IBubble> = (props) => {
    const { time, text, side } = props

    const styles = getStyles("bubble", [side])
    const formattedTime = formatTimeToHoursMinute(time)

    return (
        <div className={styles}>
            <div className={"bubble__message"}>
                <Markdown className={"paragraph paragraph--1"}>
                    {text}
                </Markdown>
            </div>
            <div className={"bubble__time"}>
                <Paragraph variant={2} className={"grey"}>
                    {formattedTime}
                </Paragraph>
            </div>
        </div>
    )
}

export default Bubble